import { BaseBus } from "./BaseBus";
import { DateFunctions } from "../static/date-functions";
import { VendorReturnDetailBus } from "./VendorReturnDetailBus";
import { CommonFunctions } from "../static/common-functions";

export class InventoryTypeBus extends BaseBus {
    constructor(busObj: BaseBus = null) {
        super(busObj);
        this.insertDt = DateFunctions.getDate(this.insertDt);
        this.updateDt = DateFunctions.getDate(this.updateDt);
    }

    CID(): any {
        return this.inventoryTypeId;
    }

    setCommon(userId: any, date: Date, companyId: any = null, personId: any = null) {
        if (!DateFunctions.isValidDate(this.insertDt)) {
            this.insertDt = date;
        }

        this.updateDt = date;
    }

    setFromForm(data: InventoryTypeBus) {
        super.setFromForm(data);
        let dateNow = CommonFunctions.getDateNow();
        this.updateDt = dateNow;
        if (this.hasId) {
            this.insertDt = data.insertDt;
        }
        else {
            this.insertDt = dateNow;
        }
    }

    setBeforeSave() {
        this.insertDt = DateFunctions.getDateTimeWithUTCOffset(this.insertDt);
    }

    inventoryTypeId: any;
    inventoryTypeName: string;
    companyId: any;
    insertDt: Date;
    updateDt: Date;
    isActive: boolean;
}
